import React from 'react';
import { styled } from '@mui/material';

interface RStatusDotProps {
    color: string;
    size?: number;
}

export function RStatusDot({ color, size = 10 }: RStatusDotProps) {
    return <Dot $color={color} $size={size} />;
}

const Dot = styled('div', { shouldForwardProp: (p) => p !== '$color' && p !== '$size' })<{
    $color: string;
    $size: number;
}>(({ $color, $size }) => ({
    width: $size,
    height: $size,
    borderRadius: '50%',
    backgroundColor: $color,
    flexShrink: 0,
}));
